import cx from 'classnames';
import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {FabricArt} from '~/common/fabric/types';
import {selectFabricArtSafe} from '~/ViewInvitation/reducers/fabricDesign';
import {FreeCardWrapper} from './FreeCardWrapper';
import {PremiumCardWrapper} from './PremiumCardWrapper';

interface DesignTemplateNewProps {
  adsPageType?: string;
  googleAdsKey?: string;
  isWebview?: boolean;
  isViewInvitationPage?: boolean;
  showPremiumWebview?: boolean;
  isPremium: boolean;
  scrollToPhotos: boolean;
  onCanPlayAnimation?: () => void;
  toggleUpsellModal?: (show: boolean, source?: string) => void;
  setAnimationComplete: () => void;
}

export const DesignTemplateNew = ({
  adsPageType,
  googleAdsKey,
  isWebview,
  isViewInvitationPage,
  showPremiumWebview,
  isPremium,
  scrollToPhotos,
  onCanPlayAnimation,
  toggleUpsellModal,
  setAnimationComplete,
}: DesignTemplateNewProps) => {
  const designTemplateRef = useRef<HTMLDivElement | null>(null);
  const fabricArt = useSelector(selectFabricArtSafe) as FabricArt;

  const showPremiumInvite =
    showPremiumWebview || (isPremium && typeof showPremiumWebview === 'undefined');

  useEffect(() => {
    if (designTemplateRef.current) {
      const initialHeight = designTemplateRef.current.getBoundingClientRect().height;
      designTemplateRef.current.style.height = `${initialHeight}px`;
    }
  }, []);

  return (
    <div
      className={cx('view-invitation__design-template-new', {
        'design-template__cf': !isViewInvitationPage,
        'design-template__free': !isPremium,
      })}
      ref={designTemplateRef}
    >
      {showPremiumInvite ? (
        <PremiumCardWrapper
          isWebview={isWebview}
          designTemplateRef={designTemplateRef}
          fabricArt={fabricArt}
          isViewInvitationPage={isViewInvitationPage}
          onCanPlayAnimation={onCanPlayAnimation}
          scrollToPhotos={scrollToPhotos}
          setAnimationComplete={setAnimationComplete}
        />
      ) : (
        <FreeCardWrapper
          designTemplateRef={designTemplateRef}
          fabricArt={fabricArt}
          toggleUpsellModal={toggleUpsellModal}
          isPremium={isPremium}
          googleAdsKey={googleAdsKey}
          adsPageType={adsPageType}
          scrollToPhotos={scrollToPhotos}
          isViewInvitationPage={isViewInvitationPage}
        />
      )}
    </div>
  );
};
